import React from "react";
import Styles from './styles.module.scss';


const MainS1 = () => {

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.textLogo} ${Styles.elementWidthWP}`}>F#ck the Fomo</div>
                <div className={`${Styles.subTextLogo}`}>be trandy</div>
            </div>
        </section>
    );
};

export default MainS1;
